// React
import React from 'react';

// Hooks and utils
import PropTypes from 'prop-types';
import format from 'date-fns/format';

// Componets
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { injectIntl, FormattedMessage } from 'react-intl';
import ADGMItemDetails from 'aurora-components/ADGMItemDetails/ADGMItemDetails';
import messages from 'aurora-translations';

// Styles
import styles from './styles';

function SecondPartyDisplay(props) {
  const { classes, company, pmaType, individual, locale, secondPartyType } = props;

  return (
    <div className={classes.contentArea}>
      {(pmaType === 'PMC' || secondPartyType === 'COMPANY') && (
        <Paper variant='outlined' className={classes.paperCardFrame}>
          <div className={classes.titleHead}>
            <Typography variant='h6' component='h1' className={classes.Title}>
              {/* {pmaType === 'FreeholdPropertyManagementAgreement' && <FormattedMessage {...messages.company_details} />} */}
              {/* {pmaType === 'PMC' && */}
              <FormattedMessage {...messages.second_party} />
              {/* } */}
            </Typography>
          </div>
          <div className={classes.innerCardGrid}>
            <Grid container spacing={3} className={classes.innercontent}>
              <Grid item xs={12} sm={6}>
                <ADGMItemDetails label='company_name_english' value={company?.nameEn || ''} />
              </Grid>
              <Grid item spacing={3} xs={12} sm={6}>
                <ADGMItemDetails label='company_name_arabic' value={company?.nameAr || ''} />
              </Grid>
              <Grid item spacing={3} xs={12} sm={6}>
                <ADGMItemDetails label='phone_number' value={company?.phone || ''} />
              </Grid>
              <Grid item spacing={3} xs={12} sm={6}>
                <ADGMItemDetails label='Email' value={company?.email || ''} />
              </Grid>
            </Grid>
          </div>
        </Paper>
      )}

      {pmaType === 'FreeholdPropertyManagementAgreement' && secondPartyType === 'INDIVIDUAL' && (
        <Paper variant='outlined' className={classes.paperCardFrame}>
          <div className={classes.titleHead}>
            <Typography variant='h6' component='h1' className={classes.Title}>
              {/* {isRenewal ? (
                <FormattedMessage {...messages.person_details} />
              ) : ( */}
              <FormattedMessage {...messages.second_party} />
              {/* )} */}
            </Typography>
          </div>
          <div className={classes.innerCardGrid}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <ADGMItemDetails
                  label='Name_lang'
                  labelPlaceholder={{ lang: 'English' }}
                  value={individual?.nameEn || ''}
                />
              </Grid>
              <Grid item spacing={3} xs={12} sm={6}>
                <ADGMItemDetails
                  label='Name_lang'
                  labelPlaceholder={{ lang: 'Arabic' }}
                  value={individual?.nameAr || ''}
                />
              </Grid>
              <Grid item spacing={3} xs={12} sm={6}>
                <ADGMItemDetails
                  label='nationality'
                  value={locale === 'en' ? individual?.nationalityEn || '' : individual?.nationalityAr}
                />
              </Grid>
              <Grid item spacing={3} xs={12} sm={6}>
                <ADGMItemDetails
                  label='Date_of_birth_DD_MM_YYYY'
                  value={individual?.birthDate ? format(new Date(individual?.birthDate), 'dd/MM/yyyy') : ''}
                />
              </Grid>
              <Grid item spacing={3} xs={12} sm={6}>
                <ADGMItemDetails
                  label='passport_issue_date'
                  value={
                    individual?.passportIssueDate ? format(new Date(individual?.passportIssueDate), 'dd/MM/yyyy') : ''
                  }
                />
              </Grid>
              <Grid item spacing={3} xs={12} sm={6}>
                <ADGMItemDetails
                  label='passport_issue_date'
                  value={
                    individual?.passportExpiryDate ? format(new Date(individual?.passportExpiryDate), 'dd/MM/yyyy') : ''
                  }
                />
              </Grid>
              <Grid item spacing={3} xs={12} sm={6}>
                <ADGMItemDetails label='phone_number' value={individual?.phone || ''} />
              </Grid>
              <Grid item spacing={3} xs={12} sm={6}>
                <ADGMItemDetails label='Email' value={individual?.email || ''} />
              </Grid>
            </Grid>
          </div>
        </Paper>
      )}
    </div>
  );
}

SecondPartyDisplay.propTypes = {
  classes: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  intl: PropTypes.object.isRequired,
  fetchCompanyDetails: PropTypes.func.isRequired,
  company: PropTypes.object.isRequired,
  pmaType: PropTypes.string.isRequired,
  individual: PropTypes.object.isRequired,
  fetchUserDetails: PropTypes.func.isRequired,
  secondPartyType: PropTypes.string.isRequired,
  // isRenewal: PropTypes.bool.isRequired,
};

export default withStyles(styles)(injectIntl(SecondPartyDisplay));
